import type { TicketSubtaskRow } from "@kundeninfo/api-client";
import type { Bestaetigungsfrage } from "@kundeninfo/ui";
import { HIERARCHY_TEXT } from "./hierarchyTexts.js";
import { openChildRows } from "./hierarchy.js";

/**
 * E435 (Spec Teilaufgaben R10): Kommt ein Ticket mit offenen direkten Kindern in eine DONE-Spalte — Status im Dialog,
 * Ziehen, „Verschieben …" —, fragt die Oberfläche gestapelt mit Zahl und Liste. Der Server erzwingt nichts, nichts wird
 * mitgeschlossen. `true` = weiter (keine offenen Kinder oder „Trotzdem erledigen").
 */
export async function confirmOpenChildren(bestaetigen: (f: Bestaetigungsfrage) => Promise<boolean>,
                                          rows: readonly TicketSubtaskRow[], spaltenName: (id: string) => string): Promise<boolean> {
  const offen = openChildRows(rows);
  if (offen.length === 0) return true;
  const person = (z: TicketSubtaskRow) => z.assignee?.name ?? (z.owner.kind === "USER" ? z.owner.user?.name ?? null : null);
  return await bestaetigen({ titel: HIERARCHY_TEXT.openChildrenTitle(offen.length),
    text: HIERARCHY_TEXT.openChildrenText(offen.map((z) => ({ title: z.title, status: spaltenName(z.columnId), person: person(z) }))),
    bestaetigenText: HIERARCHY_TEXT.openChildrenConfirm, abbrechenText: HIERARCHY_TEXT.openChildrenCancel });
}
